
var accountStore = {
  Id: '124',
  client_number: 'NAT-00124',
  'name': 'NATIONAL INSURANCE COMMISSION',
  address: '',
  email: 'kgachomo@gmail.com',
  pin_no: '123456789',
  mobile: '254725068143'
};

var clientStore = {
  Id: '124',
  client_number: 'NAT-00124',
  'name': 'NATIONAL INSURANCE COMMISSION',
  address: '',
  email: 'kgachomo@gmail.com',
  pin_no: '123456789',
  mobile: '254725068143'
};
var positions = [
  'HR Manager',
  'IT Manager',
  'CEO',
  'Controller',
  'Sales Manager',
  'Support Manager',
  'Shipping Manager',
];


//Home Screen Schemes
var schemesStore = [
  {
    "schemeID": "34",
    "policy_no": "BCLAP/2023/00002",
    "ClientNumber": "21",
    "acctype": "003",
    "interm_ID": "14",
    "bus_type": "001",
    "companyshare": "0.0",
    "cedant": null,
    "PolAnniversary": "0",
    "MinAgeLimit": "0",
    "AgeLimit": "0",
    "DepMinAge": "0",
    "DepAgeLimit": "0",
    "AdminFee": "0.0",
    "comm_rate": "8.0",
    "MarketingFeeRate": "0.0",
    "ProfitLoading": "0.0",
    "Last_uploaded_Date": null,
    "commence_date": null,
    "DateFrom": "2023-09-01 00:00:00.000",
    "End_date": "2024-08-31 00:00:00.000",
    "pay_mode": "1",
    "class_code": "2",
    "currency_code": "1",
    "total_members": "0",
    "total_sa": "0.0",
    "total_prem": "0.0",
    "gross_prem": "0.0",
    "FixedContribution": "0",
    "with_rider": "1",
    "with_categories": "1",
    "free_cover_limit": "30000000.0",
    "total_amount_received": "0.0",
    "TotalClaimPayablePerUWYear": "0.0",
    "debit_note_generated": "0",
    "total_debits": "0.0",
    "total_credits": "0.0",
    "outstanding_amount": "0.0",
    "renewed": "0",
    "quoted_premium": "0.0",
    "quoted_sum": "0.0",
    "comm_amount": "0.0",
    "MarketingFeeAmt": "0.0",
    "ProfitShareRate": "0.0",
    "ProfitShareAmt": "0.0",
    "RiderCommAmt": "0.0",
    "grace_period": "0",
    "Max_benefit": "0.0",
    "fixed_benefit": "0",
    "FixedBenefitAmt": "0.0",
    "RecordSaved": "0",
    "IsFromQuotation": "0",
    "RenewalDate": "2024-09-01 00:00:00.000",
    "UnitRate": "0.0",
    "TotalSalary": "0.0",
    "TotalGrossSalary": "0.0",
    "SchedUploaded": "0",
    "LoanIntType": "2",
    "LifeCoverFactor": "0.0",
    "IsActive": "0",
    "HasBranches": "0",
    "RiderCommPremAmt": "0.0",
    "BasicCommission": "0.0",
    "created_on": null,
    "created_by": null,
    "altered_by": "rpinochio",
    "dola": "2023-12-28 11:04:09.973",
    "DoctorCode": null,
    "PremRate": "0.0",
    "WibaDiscountRate": "0.0",
    "DiscountRate": "0.0",
    "DiscountAmt": "0.0",
    "WithDiscount": "0",
    "DeathMortalityRate": "0.0",
    "OldPolicyNo": null,
    "IsMigrated": "0",
    "isRenewal": "0",
    "PremDiff": "0.0",
    "NewRateGenerated": "0",
    "WibaComm": "0.0",
    "GlaComm": "0.0",
    "Bank": null,
    "BankBranch": null,
    "BankAccount": null,
    "SkipReinsurance": "0",
    "GpaWibaCommRate": "0.0",
    "GlaPremium": "0.0",
    "WibaPremium": "0.0",
    "MaxCIAge": "0",
    "MaxDebitNotes": "1",
    "CurrDebitNoteNo": "0",
    "ReinsEndorseNumber": "BCLAP/2023/00002/02884",
    "ReinsProcessed": "0",
    "HasCoverOptions": "0",
    "TotalCategories": "0",
    "RenewedCategories": "0",
    "HasCategWithDiffPeriods": "0",
    "SecondLifeDiscountRate": "0.0",
    "IsTakeon": "0",
    "ChargeDependentsLeb": "0",
    "IndustryDescription": null,
    "RiskPeriodFrom": null,
    "RiskPeriodTo": null,
    "IsCoinsured": "0",
    "ChargeLebIndivudually": "0",
    "ApplyIndividualDiscount": "0",
    "UseGroupPolicyNo": null,
    "SchemeDescription": "KWFT CUSTOMERS CREDIT LIFE",
    "UseGroupLimits": "0",
    "ExchangeRate": "1.0",
    "UserTenor": "0",
    "uw_year": "2023",
    "MaxDependentsDeathspaid": "0",
    "ReinsPremRate": "3.5",
    "RetentionRate": "0.0",
    "AdminRate2": "0.0",
    "ValDataProcessed": "0",
    "ValReinsChecked": "0",
    "RidersGenerated": "0",
    "RiderPremium": "0.0",
    "isStaffInsurance": "0",
    "isAgentInsurance": "0",
    "UseSplitPricing": "1",
    "loan_ac": null,
    "OccupClass": null,
    "PremAllocationRate": "0.0",
    "CompanyName": "KENYA WOMEN MICROFINANCE BANK",
    "UseRateTable": "0",
    "ForAllCategories": "0",
    "LcPremium": "0.0",
    "OneOffDiscount": "0",
    "StatusCode": null,
    "WithLienOption": "0",
    "IsSubmitted": "0",
    "IsApproved": "0",
    "ApprovedBy": null,
    "ApprovedOn": null,
    "SubmittedOn": null,
    "SubmittedBy": null,
    "CancelDate": null,
    "CancelReason": null,
    "AccessType": "1",
    "ReinsOption": "1",
    "PHCFAmt": "0.0",
    "StampDutyAmt": "0.0",
    "DiscCriteria": null,
    "CoverPeriod": "366.0",
    "AdminFeeAmount": "0.0",
    "UseFixedPremForJoiners": "0",
    "JoinersFixedPrem": "0.0",
    "AdditionalLebPremium": "0.0",
    "PremAwaitingApproval": "0.0",
    "RiderPremAwaitingApproval": "0.0",
    "overpayment": "0.0",
    "IsDeclined": "0",
    "DeclinedBy": null,
    "DeclinedOn": null,
    "IgnoreRateTable": "0",
    "AgeBasedRate": "0.0",
    "JointLifeDisc": "20.0",
    "UseMemberRate": "0",
    "IgnoreProratePrem": "0",
    "BusinessOwner": null,
    "IsLoaded": "0",
    "LoadingRate": "0.0",
    "LoadedPremium": "0.0",
    "AllocateCreditLifePrems": "0",
    "NextClaimsBatchNo": "0",
    "UseSchemeDefinedAgeLimits": "0",
    "MedicalAge": "0",
    "MaxAge": "0",
    "ExcludePHCF": "0",
    "UseTableForLoanBalanceCalc": "0",
    "SalesExecutive": null,
    "ProratePremiums": null,
    "TotalClaimsIncurred": "0.0",
    "IsMinPremApplicable": "0",
    "MinimumPremium": "0.0"
  },
  {
    "schemeID": "35",
    "policy_no": "BCLAP/2023/00003",
    "ClientNumber": "21",
    "acctype": "003",
    "interm_ID": "14",
    "bus_type": "001",
    "companyshare": "0.0",
    "cedant": null,
    "PolAnniversary": "0",
    "MinAgeLimit": "0",
    "AgeLimit": "0",
    "DepMinAge": "0",
    "DepAgeLimit": "0",
    "AdminFee": "0.0",
    "comm_rate": "8.0",
    "MarketingFeeRate": "0.0",
    "ProfitLoading": "0.0",
    "Last_uploaded_Date": null,
    "commence_date": null,
    "DateFrom": "2023-09-01 00:00:00.000",
    "End_date": "2024-08-31 00:00:00.000",
    "pay_mode": "1",
    "class_code": "2",
    "currency_code": "1",
    "total_members": "25",
    "total_sa": "167446837.12999997",
    "total_prem": "33981.923098499996",
    "gross_prem": "569845.00102850003",
    "FixedContribution": "0",
    "with_rider": "1",
    "with_categories": "0",
    "free_cover_limit": "30000000.0",
    "total_amount_received": "0.0",
    "TotalClaimPayablePerUWYear": "0.0",
    "debit_note_generated": "0",
    "total_debits": "0.0",
    "total_credits": "0.0",
    "outstanding_amount": "0.0",
    "renewed": "0",
    "quoted_premium": "0.0",
    "quoted_sum": "0.0",
    "comm_amount": "45584.400082280001",
    "MarketingFeeAmt": "0.0",
    "ProfitShareRate": "0.0",
    "ProfitShareAmt": "0.0",
    "RiderCommAmt": "0.0",
    "grace_period": "0",
    "Max_benefit": "0.0",
    "fixed_benefit": "0",
    "FixedBenefitAmt": "0.0",
    "RecordSaved": "0",
    "IsFromQuotation": "0",
    "RenewalDate": "2024-09-01 00:00:00.000",
    "UnitRate": "0.0",
    "TotalSalary": "0.0",
    "TotalGrossSalary": "0.0",
    "SchedUploaded": "1",
    "LoanIntType": "2",
    "LifeCoverFactor": "0.0",
    "IsActive": "0",
    "HasBranches": "0",
    "RiderCommPremAmt": "0.0",
    "BasicCommission": "0.0",
    "created_on": null,
    "created_by": null,
    "altered_by": "rpinochio",
    "dola": "2024-01-02 10:17:46.170",
    "DoctorCode": null,
    "PremRate": "3.5",
    "WibaDiscountRate": "0.0",
    "DiscountRate": "0.0",
    "DiscountAmt": "0.0",
    "WithDiscount": "0",
    "DeathMortalityRate": "0.0",
    "OldPolicyNo": null,
    "IsMigrated": "0",
    "isRenewal": "0",
    "PremDiff": "0.0",
    "NewRateGenerated": "0",
    "WibaComm": "0.0",
    "GlaComm": "45584.400082280001",
    "Bank": null,
    "BankBranch": null,
    "BankAccount": null,
    "SkipReinsurance": "0",
    "GpaWibaCommRate": "0.0",
    "GlaPremium": "569805.00102850003",
    "WibaPremium": "0.0",
    "MaxCIAge": "0",
    "MaxDebitNotes": "1",
    "CurrDebitNoteNo": "0",
    "ReinsEndorseNumber": "BCLAP/2023/00003/04286",
    "ReinsProcessed": "0",
    "HasCoverOptions": "0",
    "TotalCategories": "0",
    "RenewedCategories": "0",
    "HasCategWithDiffPeriods": "0",
    "SecondLifeDiscountRate": "0.0",
    "IsTakeon": "0",
    "ChargeDependentsLeb": "0",
    "IndustryDescription": null,
    "RiskPeriodFrom": null,
    "RiskPeriodTo": null,
    "IsCoinsured": "0",
    "ChargeLebIndivudually": "0",
    "ApplyIndividualDiscount": "0",
    "UseGroupPolicyNo": null,
    "SchemeDescription": "KWFT - NCBA STAFF MORTGAGE",
    "UseGroupLimits": "0",
    "ExchangeRate": "1.0",
    "UserTenor": "0",
    "uw_year": "2023",
    "MaxDependentsDeathspaid": "0",
    "ReinsPremRate": "3.5",
    "RetentionRate": "0.0",
    "AdminRate2": "0.0",
    "ValDataProcessed": "0",
    "ValReinsChecked": "0",
    "RidersGenerated": "0",
    "RiderPremium": "33981.923098499996",
    "isStaffInsurance": "0",
    "isAgentInsurance": "0",
    "UseSplitPricing": "1",
    "loan_ac": null,
    "OccupClass": null,
    "PremAllocationRate": "0.0",
    "CompanyName": "KENYA WOMEN MICROFINANCE BANK",
    "UseRateTable": "0",
    "ForAllCategories": "0",
    "LcPremium": "0.0",
    "OneOffDiscount": "0",
    "StatusCode": null,
    "WithLienOption": "0",
    "IsSubmitted": "0",
    "IsApproved": "0",
    "ApprovedBy": null,
    "ApprovedOn": null,
    "SubmittedOn": null,
    "SubmittedBy": null,
    "CancelDate": null,
    "CancelReason": null,
    "AccessType": "1",
    "ReinsOption": "1",
    "PHCFAmt": "0.0",
    "StampDutyAmt": "40.0",
    "DiscCriteria": null,
    "CoverPeriod": "366.0",
    "AdminFeeAmount": "0.0",
    "UseFixedPremForJoiners": "0",
    "JoinersFixedPrem": "0.0",
    "AdditionalLebPremium": "0.0",
    "PremAwaitingApproval": "0.0",
    "RiderPremAwaitingApproval": "0.0",
    "overpayment": "0.0",
    "IsDeclined": "0",
    "DeclinedBy": null,
    "DeclinedOn": null,
    "IgnoreRateTable": "0",
    "AgeBasedRate": "0.0",
    "JointLifeDisc": "0.0",
    "UseMemberRate": "0",
    "IgnoreProratePrem": "0",
    "BusinessOwner": null,
    "IsLoaded": "0",
    "LoadingRate": "0.0",
    "LoadedPremium": "0.0",
    "AllocateCreditLifePrems": "1",
    "NextClaimsBatchNo": "0",
    "UseSchemeDefinedAgeLimits": "0",
    "MedicalAge": "0",
    "MaxAge": "0",
    "ExcludePHCF": "0",
    "UseTableForLoanBalanceCalc": "0",
    "SalesExecutive": null,
    "ProratePremiums": null,
    "TotalClaimsIncurred": "0.0",
    "IsMinPremApplicable": "0",
    "MinimumPremium": "0.0"
  }
];


var claimsStore = [
  {
    "id": "3",
    "BatchNumber": null,
    "SchemeName": "4",
    "MemberIdKey": "2644",
    "claim_no": "GL/APE/011/2023",
    "claim_type": "NAT",
    "IsNOTFirstRetrenchMentInstallment": "0",
    "branch_id": "100",
    "event_date": "2023-08-29 00:00:00.000",
    "FuneralMember": null,
    "ShowRetrenchementFields": "0",
    "CurrentLoanAmount": "0.0",
    "TotalLoanRepayment": "0.0",
    "NETsalary": "0.0",
    "TotalCreditLifeDeathAmount": "0.0",
    "ShowTotalCreditLifeDeathAmount": "0",
    "TotalInstallmentValue": "0",
    "UwYear": "2023",
    "claimant": "Richard Kiplagat ",
    "notification_date": "2023-09-21 00:00:00.000",
    "LoanRepaymentDate": null,
    "admitted": "1",
    "dateAdmitted": null,
    "CheckDeathClaim": "1",
    "ShowClaimCause": "1",
    "ClaimCause": "1",
    "ProximateCause": null,
    "PaymentStatus": null,
    "Movedtounclaimedassets": "0",
    "statusCode": "001",
    "total_proceeds": "82565461.200000003",
    "total_deductions": "0.0",
    "net_payment": "82565461.200000003",
    "pay_due_date": "2023-08-29 00:00:00.000",
    "PayBeneficiary": "0",
    "PayScheme": "1",
    "IsLebClaim": "0",
    "AllowProcessing": "0",
    "processed": "1",
    "Approved": "0",
    "counter": "0",
    "IsCancelled": "0",
    "IsReversed": "0",
    "isdecline": "0",
    "IsBulkRetrenchment": "0",
    "IsBulkProccessed": "0",
    "canceled_by": null,
    "Cancel_narration": null,
    "canceled_date": null,
    "IsXgratia": "0",
    "ShowExgratiaOptions": "0",
    "PreviousClaims": null,
    "PreviousPaidAmount": "0.0",
    "Exgratia_amount": "0.0",
    "ExgratiaNarration": null,
    "ExcludeFromExgratia": "0",
    "RecordSaved": "1",
    "SubmittedBy": null,
    "IsSubmitted": "0",
    "DVApproved": "0",
    "SubmittedOn": null,
    "RetrechmentPayOutID": "0",
    "TotalPayableAmt": "0.0",
    "HoldForInvestigation": "0",
    "Ispending": "0",
    "Rejected": "0",
    "RejectReason": null,
    "RejectedOn": null,
    "created_by": "fkriungu",
    "created_on": "2023-09-21 16:14:47.297",
    "altered_by": "fkriungu",
    "dola": "2023-09-21 00:00:00.000",
    "FlagShowFuneralMembers": "1",
    "ShowReversal_cancellationHistory": "0",
    "HasReinsuranceDetails": "0",
    "SchemeBenefit": "15",
    "Original_SA": "82565461.200000003",
    "CancerType": null,
    "DeathCertNo": null,
    "DeathEntryNo": null,
    "OtherCancerType": null,
    "ClaimReason": "26",
    "NotificationComment": null,
    "PolicyNumber": "BGLAP/2023/00003",
    "RejectedBy": null,
    "ShowLifeAssured": "0",
    "glifeclaimsnotificationCTRLinitilization": "0",
    "CancellationNarationVAR": null,
    "MaxDependentspaid": null,
    "InvestigationComment": null,
    "SentForApproval": "1",
    "IsForIBNR": "0",
    "IBNRAmount": null,
    "IsLastExpense": "0",
    "ProcessdBy": "Admin",
    "ProcessedOn": "2023-10-06 12:13:09.000",
    "ApprovalBy": "0E6E46F5-2FD7-4ADD-BF5E-D9405FD776F2",
    "IntermediaryName": null,
    "ClaimBatchNumber": null,
    "LastExpenseProcessed": null,
    "DVProcessedOn": null,
    "DVProcessedBy": null,
    "EmployeeName": null,
    "LifeAssured": null,
    "BeneficiaryName": null,
    "RequestForRejection": null,
    "RejectionComment": null,
    "AssignToBatch": null,
    "AssignedBatch": null,
    "IsMigration": null,
    "OldClaimNumber": null,
    "ApprovedBy": null,
    "ApprovedOn": null,
    "ClaimTAT": null,
    "DateSentForInvestigation": null,
    "SentForInvestigationBy": null,
    "claimevent": null,
    "PayUFAA": null,
    "BouncedPayment": null,
    "ClaimPaid": null,
    "DateClaimPaid": null,
    "VoidedPayment": null,
    "ShowLoanRepaymentFields": null,
    "ForNewMember": null,
    "IsPreviousClaim": null,
    "IsForMember": null,
    "ReimClaimNumber": null,
    "InterestRate": null,
    "PayLeadInsurer": null,
    "PayLeadCoinsurer": null,
    "DateofBirth": null,
    "YearofDeath": null,
    "YOD": null,
    "LoanNumber": null,
    "HasMultipleLoans": null,
    "InstallmentNumber": null,
    "FirstInstallment": null,
    "EffectiveDate": null,
    "WithInterestChange": null,
    "ExgratiaFor": null,
    "ProcessOwner": null,
    "ManagerClaims": null,
    "RiskManager": null,
    "BarnowlDate": null,
    "RiskIncidentOne": null,
    "RiskIncidentTwo": null,
    "LossEventType": null,
    "EventDiscoveryDate": null,
    "GrossRiskRating": null,
    "ResidualRiskRating": null
  },
  {
    "id": "4",
    "BatchNumber": null,
    "SchemeName": "4",
    "MemberIdKey": "2645",
    "claim_no": "GL/APE/010/2023",
    "claim_type": "NAT",
    "IsNOTFirstRetrenchMentInstallment": "0",
    "branch_id": "100",
    "event_date": "2023-08-28 00:00:00.000",
    "FuneralMember": null,
    "ShowRetrenchementFields": "0",
    "CurrentLoanAmount": "0.0",
    "TotalLoanRepayment": "0.0",
    "NETsalary": "0.0",
    "TotalCreditLifeDeathAmount": "0.0",
    "ShowTotalCreditLifeDeathAmount": "0",
    "TotalInstallmentValue": "0",
    "UwYear": "2023",
    "claimant": "Margarita Dimova ",
    "notification_date": "2023-09-21 00:00:00.000",
    "LoanRepaymentDate": null,
    "admitted": "1",
    "dateAdmitted": null,
    "CheckDeathClaim": "1",
    "ShowClaimCause": "1",
    "ClaimCause": "1",
    "ProximateCause": null,
    "PaymentStatus": null,
    "Movedtounclaimedassets": "0",
    "statusCode": "001",
    "total_proceeds": "60514337.799999997",
    "total_deductions": "0.0",
    "net_payment": "60514337.799999997",
    "pay_due_date": "2023-08-28 00:00:00.000",
    "PayBeneficiary": "0",
    "PayScheme": "1",
    "IsLebClaim": "0",
    "AllowProcessing": "0",
    "processed": "1",
    "Approved": "0",
    "counter": "0",
    "IsCancelled": "0",
    "IsReversed": "0",
    "isdecline": "0",
    "IsBulkRetrenchment": "0",
    "IsBulkProccessed": "0",
    "canceled_by": null,
    "Cancel_narration": null,
    "canceled_date": null,
    "IsXgratia": "0",
    "ShowExgratiaOptions": "0",
    "PreviousClaims": null,
    "PreviousPaidAmount": "0.0",
    "Exgratia_amount": "0.0",
    "ExgratiaNarration": null,
    "ExcludeFromExgratia": "0",
    "RecordSaved": "1",
    "SubmittedBy": null,
    "IsSubmitted": "0",
    "DVApproved": "0",
    "SubmittedOn": null,
    "RetrechmentPayOutID": "0",
    "TotalPayableAmt": "0.0",
    "HoldForInvestigation": "0",
    "Ispending": "0",
    "Rejected": "0",
    "RejectReason": null,
    "RejectedOn": null,
    "created_by": "fkriungu",
    "created_on": "2023-09-21 16:11:05.583",
    "altered_by": "fkriungu",
    "dola": "2023-09-28 00:00:00.000",
    "FlagShowFuneralMembers": "1",
    "ShowReversal_cancellationHistory": "0",
    "HasReinsuranceDetails": "0",
    "SchemeBenefit": "15",
    "Original_SA": "60714337.799999997",
    "CancerType": null,
    "DeathCertNo": null,
    "DeathEntryNo": null,
    "OtherCancerType": null,
    "ClaimReason": "26",
    "NotificationComment": null,
    "PolicyNumber": "BGLAP/2023/00003",
    "RejectedBy": null,
    "ShowLifeAssured": "0",
    "glifeclaimsnotificationCTRLinitilization": "0",
    "CancellationNarationVAR": null,
    "MaxDependentspaid": null,
    "InvestigationComment": null,
    "SentForApproval": "0",
    "IsForIBNR": "0",
    "IBNRAmount": null,
    "IsLastExpense": "0",
    "ProcessdBy": "vielva",
    "ProcessedOn": "2023-10-06 11:30:45.000",
    "ApprovalBy": null,
    "IntermediaryName": null,
    "ClaimBatchNumber": null,
    "LastExpenseProcessed": null,
    "DVProcessedOn": null,
    "DVProcessedBy": null,
    "EmployeeName": null,
    "LifeAssured": null,
    "BeneficiaryName": null,
    "RequestForRejection": null,
    "RejectionComment": null,
    "AssignToBatch": null,
    "AssignedBatch": null,
    "IsMigration": null,
    "OldClaimNumber": null,
    "ApprovedBy": null,
    "ApprovedOn": null,
    "ClaimTAT": null,
    "DateSentForInvestigation": null,
    "SentForInvestigationBy": null,
    "claimevent": null,
    "PayUFAA": null,
    "BouncedPayment": null,
    "ClaimPaid": null,
    "DateClaimPaid": null,
    "VoidedPayment": null,
    "ShowLoanRepaymentFields": null,
    "ForNewMember": null,
    "IsPreviousClaim": null,
    "IsForMember": null,
    "ReimClaimNumber": null,
    "InterestRate": null,
    "PayLeadInsurer": null,
    "PayLeadCoinsurer": null,
    "DateofBirth": null,
    "YearofDeath": null,
    "YOD": null,
    "LoanNumber": null,
    "HasMultipleLoans": null,
    "InstallmentNumber": null,
    "FirstInstallment": null,
    "EffectiveDate": null,
    "WithInterestChange": null,
    "ExgratiaFor": null,
    "ProcessOwner": null,
    "ManagerClaims": null,
    "RiskManager": null,
    "BarnowlDate": null,
    "RiskIncidentOne": null,
    "RiskIncidentTwo": null,
    "LossEventType": null,
    "EventDiscoveryDate": null,
    "GrossRiskRating": null,
    "ResidualRiskRating": null
  },
  {
    "id": "5",
    "BatchNumber": null,
    "SchemeName": "4",
    "MemberIdKey": "2645",
    "claim_no": "GL/TA/089/2023",
    "claim_type": "5",
    "IsNOTFirstRetrenchMentInstallment": "0",
    "branch_id": "100",
    "event_date": "2023-09-04 00:00:00.000",
    "FuneralMember": null,
    "ShowRetrenchementFields": "0",
    "CurrentLoanAmount": "0.0",
    "TotalLoanRepayment": "0.0",
    "NETsalary": "0.0",
    "TotalCreditLifeDeathAmount": "0.0",
    "ShowTotalCreditLifeDeathAmount": "0",
    "TotalInstallmentValue": "0",
    "UwYear": "2023",
    "claimant": "Margarita Dimova ",
    "notification_date": "2023-09-28 00:00:00.000",
    "LoanRepaymentDate": null,
    "admitted": "1",
    "dateAdmitted": null,
    "CheckDeathClaim": "1",
    "ShowClaimCause": "1",
    "ClaimCause": "1",
    "ProximateCause": null,
    "PaymentStatus": null,
    "Movedtounclaimedassets": "0",
    "statusCode": "001",
    "total_proceeds": "50000.0",
    "total_deductions": "0.0",
    "net_payment": "50000.0",
    "pay_due_date": "2023-09-04 00:00:00.000",
    "PayBeneficiary": "0",
    "PayScheme": "1",
    "IsLebClaim": "1",
    "AllowProcessing": "0",
    "processed": "1",
    "Approved": "1",
    "counter": "0",
    "IsCancelled": "0",
    "IsReversed": "0",
    "isdecline": "0",
    "IsBulkRetrenchment": "0",
    "IsBulkProccessed": "0",
    "canceled_by": null,
    "Cancel_narration": null,
    "canceled_date": null,
    "IsXgratia": "0",
    "ShowExgratiaOptions": "0",
    "PreviousClaims": null,
    "PreviousPaidAmount": "0.0",
    "Exgratia_amount": "0.0",
    "ExgratiaNarration": null,
    "ExcludeFromExgratia": "0",
    "RecordSaved": "1",
    "SubmittedBy": null,
    "IsSubmitted": "0",
    "DVApproved": "0",
    "SubmittedOn": null,
    "RetrechmentPayOutID": "0",
    "TotalPayableAmt": "0.0",
    "HoldForInvestigation": "0",
    "Ispending": "0",
    "Rejected": "0",
    "RejectReason": null,
    "RejectedOn": null,
    "created_by": "fkriungu",
    "created_on": "2023-09-28 16:16:23.833",
    "altered_by": "fkriungu",
    "dola": "2023-09-28 00:00:00.000",
    "FlagShowFuneralMembers": "1",
    "ShowReversal_cancellationHistory": "0",
    "HasReinsuranceDetails": "0",
    "SchemeBenefit": "14",
    "Original_SA": "50000.0",
    "CancerType": null,
    "DeathCertNo": null,
    "DeathEntryNo": null,
    "OtherCancerType": null,
    "ClaimReason": "26",
    "NotificationComment": null,
    "PolicyNumber": "BGLAP/2023/00003",
    "RejectedBy": null,
    "ShowLifeAssured": "0",
    "glifeclaimsnotificationCTRLinitilization": "0",
    "CancellationNarationVAR": null,
    "MaxDependentspaid": null,
    "InvestigationComment": null,
    "SentForApproval": "0",
    "IsForIBNR": "0",
    "IBNRAmount": null,
    "IsLastExpense": "0",
    "ProcessdBy": "vielva",
    "ProcessedOn": "2023-10-06 11:30:45.000",
    "ApprovalBy": null,
    "IntermediaryName": null,
    "ClaimBatchNumber": null,
    "LastExpenseProcessed": null,
    "DVProcessedOn": null,
    "DVProcessedBy": null,
    "EmployeeName": null,
    "LifeAssured": null,
    "BeneficiaryName": null,
    "RequestForRejection": null,
    "RejectionComment": null,
    "AssignToBatch": null,
    "AssignedBatch": null,
    "IsMigration": null,
    "OldClaimNumber": null,
    "ApprovedBy": null,
    "ApprovedOn": null,
    "ClaimTAT": null,
    "DateSentForInvestigation": null,
    "SentForInvestigationBy": null,
    "claimevent": null,
    "PayUFAA": null,
    "BouncedPayment": null,
    "ClaimPaid": null,
    "DateClaimPaid": null,
    "VoidedPayment": null,
    "ShowLoanRepaymentFields": null,
    "ForNewMember": null,
    "IsPreviousClaim": null,
    "IsForMember": null,
    "ReimClaimNumber": null,
    "InterestRate": null,
    "PayLeadInsurer": null,
    "PayLeadCoinsurer": null,
    "DateofBirth": null,
    "YearofDeath": null,
    "YOD": null,
    "LoanNumber": null,
    "HasMultipleLoans": null,
    "InstallmentNumber": null,
    "FirstInstallment": null,
    "EffectiveDate": null,
    "WithInterestChange": null,
    "ExgratiaFor": null,
    "ProcessOwner": null,
    "ManagerClaims": null,
    "RiskManager": null,
    "BarnowlDate": null,
    "RiskIncidentOne": null,
    "RiskIncidentTwo": null,
    "LossEventType": null,
    "EventDiscoveryDate": null,
    "GrossRiskRating": null,
    "ResidualRiskRating": null
  },
  {
    "id": "6",
    "BatchNumber": null,
    "SchemeName": "4",
    "MemberIdKey": "2645",
    "claim_no": "GL/TA/090/2023",
    "claim_type": "11",
    "IsNOTFirstRetrenchMentInstallment": "0",
    "branch_id": "100",
    "event_date": "2023-09-03 00:00:00.000",
    "FuneralMember": null,
    "ShowRetrenchementFields": "0",
    "CurrentLoanAmount": "0.0",
    "TotalLoanRepayment": "0.0",
    "NETsalary": "0.0",
    "TotalCreditLifeDeathAmount": "0.0",
    "ShowTotalCreditLifeDeathAmount": "0",
    "TotalInstallmentValue": "0",
    "UwYear": "2023",
    "claimant": "Margarita Dimova ",
    "notification_date": "2023-09-28 00:00:00.000",
    "LoanRepaymentDate": null,
    "admitted": "1",
    "dateAdmitted": null,
    "CheckDeathClaim": "1",
    "ShowClaimCause": "1",
    "ClaimCause": "1",
    "ProximateCause": null,
    "PaymentStatus": null,
    "Movedtounclaimedassets": "0",
    "statusCode": "001",
    "total_proceeds": "200000.0",
    "total_deductions": "0.0",
    "net_payment": "200000.0",
    "pay_due_date": "2023-09-03 00:00:00.000",
    "PayBeneficiary": "0",
    "PayScheme": "1",
    "IsLebClaim": "1",
    "AllowProcessing": "0",
    "processed": "1",
    "Approved": "0",
    "counter": "0",
    "IsCancelled": "0",
    "IsReversed": "0",
    "isdecline": "0",
    "IsBulkRetrenchment": "0",
    "IsBulkProccessed": "0",
    "canceled_by": null,
    "Cancel_narration": null,
    "canceled_date": null,
    "IsXgratia": "0",
    "ShowExgratiaOptions": "0",
    "PreviousClaims": null,
    "PreviousPaidAmount": "0.0",
    "Exgratia_amount": "0.0",
    "ExgratiaNarration": null,
    "ExcludeFromExgratia": "0",
    "RecordSaved": "1",
    "SubmittedBy": null,
    "IsSubmitted": "0",
    "DVApproved": "0",
    "SubmittedOn": null,
    "RetrechmentPayOutID": "0",
    "TotalPayableAmt": "0.0",
    "HoldForInvestigation": "0",
    "Ispending": "0",
    "Rejected": "0",
    "RejectReason": null,
    "RejectedOn": null,
    "created_by": "fkriungu",
    "created_on": "2023-09-28 16:19:40.420",
    "altered_by": "fkriungu",
    "dola": "2023-09-28 00:00:00.000",
    "FlagShowFuneralMembers": "1",
    "ShowReversal_cancellationHistory": "0",
    "HasReinsuranceDetails": "0",
    "SchemeBenefit": "17",
    "Original_SA": "200000.0",
    "CancerType": null,
    "DeathCertNo": null,
    "DeathEntryNo": null,
    "OtherCancerType": null,
    "ClaimReason": "26",
    "NotificationComment": null,
    "PolicyNumber": "BGLAP/2023/00003",
    "RejectedBy": null,
    "ShowLifeAssured": "0",
    "glifeclaimsnotificationCTRLinitilization": "0",
    "CancellationNarationVAR": null,
    "MaxDependentspaid": null,
    "InvestigationComment": null,
    "SentForApproval": "0",
    "IsForIBNR": "0",
    "IBNRAmount": null,
    "IsLastExpense": "0",
    "ProcessdBy": "vielva",
    "ProcessedOn": "2023-10-06 11:30:45.000",
    "ApprovalBy": null,
    "IntermediaryName": null,
    "ClaimBatchNumber": null,
    "LastExpenseProcessed": null,
    "DVProcessedOn": null,
    "DVProcessedBy": null,
    "EmployeeName": null,
    "LifeAssured": null,
    "BeneficiaryName": null,
    "RequestForRejection": null,
    "RejectionComment": null,
    "AssignToBatch": null,
    "AssignedBatch": null,
    "IsMigration": null,
    "OldClaimNumber": null,
    "ApprovedBy": null,
    "ApprovedOn": null,
    "ClaimTAT": null,
    "DateSentForInvestigation": null,
    "SentForInvestigationBy": null,
    "claimevent": null,
    "PayUFAA": null,
    "BouncedPayment": null,
    "ClaimPaid": null,
    "DateClaimPaid": null,
    "VoidedPayment": null,
    "ShowLoanRepaymentFields": null,
    "ForNewMember": null,
    "IsPreviousClaim": null,
    "IsForMember": null,
    "ReimClaimNumber": null,
    "InterestRate": null,
    "PayLeadInsurer": null,
    "PayLeadCoinsurer": null,
    "DateofBirth": null,
    "YearofDeath": null,
    "YOD": null,
    "LoanNumber": null,
    "HasMultipleLoans": null,
    "InstallmentNumber": null,
    "FirstInstallment": null,
    "EffectiveDate": null,
    "WithInterestChange": null,
    "ExgratiaFor": null,
    "ProcessOwner": null,
    "ManagerClaims": null,
    "RiskManager": null,
    "BarnowlDate": null,
    "RiskIncidentOne": null,
    "RiskIncidentTwo": null,
    "LossEventType": null,
    "EventDiscoveryDate": null,
    "GrossRiskRating": null,
    "ResidualRiskRating": null
  },
  {
    "id": "7",
    "BatchNumber": null,
    "SchemeName": "4",
    "MemberIdKey": "2646",
    "claim_no": "GL/APE/007/2023",
    "claim_type": "4",
    "IsNOTFirstRetrenchMentInstallment": "0",
    "branch_id": "100",
    "event_date": "2023-08-28 00:00:00.000",
    "FuneralMember": null,
    "ShowRetrenchementFields": "0",
    "CurrentLoanAmount": "0.0",
    "TotalLoanRepayment": "0.0",
    "NETsalary": "0.0",
    "TotalCreditLifeDeathAmount": "0.0",
    "ShowTotalCreditLifeDeathAmount": "0",
    "TotalInstallmentValue": "0",
    "UwYear": "2023",
    "claimant": "Samuel Ayiro ",
    "notification_date": "2023-09-21 00:00:00.000",
    "LoanRepaymentDate": null,
    "admitted": "1",
    "dateAdmitted": null,
    "CheckDeathClaim": "0",
    "ShowClaimCause": "1",
    "ClaimCause": "1",
    "ProximateCause": null,
    "PaymentStatus": null,
    "Movedtounclaimedassets": "0",
    "statusCode": "001",
    "total_proceeds": "4500000.0",
    "total_deductions": "0.0",
    "net_payment": "4500000.0",
    "pay_due_date": "2023-08-28 00:00:00.000",
    "PayBeneficiary": "0",
    "PayScheme": "1",
    "IsLebClaim": "0",
    "AllowProcessing": "0",
    "processed": "1",
    "Approved": "1",
    "counter": "0",
    "IsCancelled": "0",
    "IsReversed": "0",
    "isdecline": "0",
    "IsBulkRetrenchment": "0",
    "IsBulkProccessed": "0",
    "canceled_by": null,
    "Cancel_narration": null,
    "canceled_date": null,
    "IsXgratia": "0",
    "ShowExgratiaOptions": "0",
    "PreviousClaims": null,
    "PreviousPaidAmount": "0.0",
    "Exgratia_amount": "0.0",
    "ExgratiaNarration": null,
    "ExcludeFromExgratia": "0",
    "RecordSaved": "1",
    "SubmittedBy": null,
    "IsSubmitted": "0",
    "DVApproved": "0",
    "SubmittedOn": null,
    "RetrechmentPayOutID": "0",
    "TotalPayableAmt": "0.0",
    "HoldForInvestigation": "0",
    "Ispending": "0",
    "Rejected": "0",
    "RejectReason": null,
    "RejectedOn": null,
    "created_by": "fkriungu",
    "created_on": "2023-09-21 15:01:51.590",
    "altered_by": "fkriungu",
    "dola": "2023-09-21 00:00:00.000",
    "FlagShowFuneralMembers": "1",
    "ShowReversal_cancellationHistory": "0",
    "HasReinsuranceDetails": "0",
    "SchemeBenefit": "18",
    "Original_SA": "12825000.0",
    "CancerType": null,
    "DeathCertNo": null,
    "DeathEntryNo": null,
    "OtherCancerType": null,
    "ClaimReason": "26",
    "NotificationComment": null,
    "PolicyNumber": "BGLAP/2023/00003",
    "RejectedBy": null,
    "ShowLifeAssured": "0",
    "glifeclaimsnotificationCTRLinitilization": "0",
    "CancellationNarationVAR": null,
    "MaxDependentspaid": null,
    "InvestigationComment": null,
    "SentForApproval": "0",
    "IsForIBNR": "0",
    "IBNRAmount": null,
    "IsLastExpense": "0",
    "ProcessdBy": "vielva",
    "ProcessedOn": "2023-10-06 11:30:45.000",
    "ApprovalBy": null,
    "IntermediaryName": null,
    "ClaimBatchNumber": null,
    "LastExpenseProcessed": null,
    "DVProcessedOn": null,
    "DVProcessedBy": null,
    "EmployeeName": null,
    "LifeAssured": null,
    "BeneficiaryName": null,
    "RequestForRejection": null,
    "RejectionComment": null,
    "AssignToBatch": null,
    "AssignedBatch": null,
    "IsMigration": null,
    "OldClaimNumber": null,
    "ApprovedBy": null,
    "ApprovedOn": null,
    "ClaimTAT": null,
    "DateSentForInvestigation": null,
    "SentForInvestigationBy": null,
    "claimevent": null,
    "PayUFAA": null,
    "BouncedPayment": null,
    "ClaimPaid": null,
    "DateClaimPaid": null,
    "VoidedPayment": null,
    "ShowLoanRepaymentFields": null,
    "ForNewMember": null,
    "IsPreviousClaim": null,
    "IsForMember": null,
    "ReimClaimNumber": null,
    "InterestRate": null,
    "PayLeadInsurer": null,
    "PayLeadCoinsurer": null,
    "DateofBirth": null,
    "YearofDeath": null,
    "YOD": null,
    "LoanNumber": null,
    "HasMultipleLoans": null,
    "InstallmentNumber": null,
    "FirstInstallment": null,
    "EffectiveDate": null,
    "WithInterestChange": null,
    "ExgratiaFor": null,
    "ProcessOwner": null,
    "ManagerClaims": null,
    "RiskManager": null,
    "BarnowlDate": null,
    "RiskIncidentOne": null,
    "RiskIncidentTwo": null,
    "LossEventType": null,
    "EventDiscoveryDate": null,
    "GrossRiskRating": null,
    "ResidualRiskRating": null
  }
];


const _bearerToken = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiMzc4YzViODhhZjdmM2IzOWEzNWFjNGIzODVhYThkZmQ5MmI1MGY0MDFmMzFmNGIzZDdjNjdmZWRhZGZjNDkyNGUwZmNlMGE1ZjM4NmEwZTUiLCJpYXQiOjE3MDU0Nzc2ODUuMTQ0NjYyLCJuYmYiOjE3MDU0Nzc2ODUuMTQ0NjY2LCJleHAiOjE3MzcxMDAwODUuMTI5NjgxLCJzdWIiOiIiLCJzY29wZXMiOltdfQ.YVX_7gsdyecvn4LtpRSJBMTryfBBDWOxNM4ztYKQ3JvS79N1vlE4QX8tIFRvXV6slgs0kacX5tH7RYaVG2l5zmqldmVlp6CIcf0YGq3NaXfiyA3_zPBxHyjgO-DsWoCOM9A-laswGoLwyokALuBtC1Q0e4_jOHaGVNz-x4ihhKPeh2rY3mf47X58LjxKfHfgK2Wvrm83GZt26FeLuwj-GYc7GuKGqKBqlc0sj29eFWGQZ1eNYrE4cI4vcp6aOtZdmbhqKVGlKkanar4p7RWeEXHYzZIyYERymHF8xpiBLElgakNreyzk-qYw_PKNp7w1PWADIp1Afy0umBI2yaeRrNuG7BlVhLphaQy77oPdnL-MDBTyuwRFRKGeyNKRZYbxvRC9xF9xi52pnvfa02zGFjtQ_NhHONzNcJimN9N3FEUh46JIRTGtR_QEmJKqAzklpA-io0Ok3IiVMNqPRXzMxZNdr3PMCd60li2rw4N5eLQkuazl5ep2uymjXJ51l9nEd6_BB_MkEQ90EsjvhV9DKf9SO1gFB2y-C4ZLHK4pOcgSzMfjkt9XljWu-yR2lRbkrX48iJ3iAJv3BeYEdXxU4WLvv6sU8g9m7CtTGQFVEkM3OqOG-k6FiQibUJsiaE__8p0Ip-LvgtRX7Mqh0poTXrSKZsQR0OJr7p92EWLGQRg";

export default {
  getAuthToken() {
    return _bearerToken;
  },
  getSchemesStore() {
    return schemesStore;
  },
  getClaimsStore() {
    return claimsStore;
  },
  getclientStore() {
    return clientStore;
  },
  setClientStore(clientData) {
    clientStore = clientData;
  },
  setSchemesStore(schemesData) {
    schemesStore = schemesData;
  },
  getPositions() {
    return positions;
  }
};
